// Routes du module « conception » : schéma fonctionnel et cheminements d'un dossier d'étude.
import type { RouteObject } from 'react-router';
import '../../styles/conception.css';
import { PageConception } from './PageConception.tsx';

export const routesConception: RouteObject[] = [
  { path: 'etudes/:id/conception', element: <PageConception /> },
];
